import { TSpeaker } from 'types'
import { v4 as uuidv4 } from 'uuid'

import SamPhoto from 'assets/images/speakers/sam.png'
import SaidPhoto from 'assets/images/speakers/said.jpg'
import PetrPhoto from 'assets/images/speakers/petr.jpg'
import HovoPhoto from 'assets/images/team/Hovo.png'
import AntonPhoto from 'assets/images/speakers/anton.png'
import DenisPhoto from 'assets/images/speakers/denis.png'
import VahanPhoto from 'assets/images/speakers/vahan.jpg'
import MariaPhoto from 'assets/images/speakers/maria.jpg'
import DazikPhoto from 'assets/images/speakers/dazik.jpg'
import IrinePhoto from 'assets/images/speakers/irine.png'
import GagikPhoto from 'assets/images/speakers/gagik.jpg'
import AlexeyPhoto from 'assets/images/speakers/alexey.jpg'
import ViktorPhoto from 'assets/images/speakers/viktor.jpg'
import NikitaPhoto from 'assets/images/speakers/nikita.jpg'
import TigranPhoto from 'assets/images/speakers/tigran.jpg'
import MikayelPhoto from 'assets/images/speakers/mikayel.jpg'
import ChristinePhoto from 'assets/images/team/Christine.png'

const speakersData2024: TSpeaker[] = [
  {
    id: uuidv4(),
    name: 'María Encinar',
    position: 'AWS User Group Global Program Lead at AWS',
    image: MariaPhoto,
    link: 'https://www.linkedin.com/in/mariaencinar?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAAFOx9cB-_4crj5hwN79EMQHsC8UuEmdcLo&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BSwptN5x1RDGXCaI8Tc%2FhYw%3D%3D',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Kristiné Armiyants',
    position: 'Cloud Support Engineer at Skyscrapers, Founder and Leader of AWS UG Armenia',
    image: ChristinePhoto,
    link: 'https://www.linkedin.com/in/kristine-armiyants-42b69b12b/',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Viktor Vedmich',
    position: 'Senior Developer Advocate at AWS',
    image: ViktorPhoto,
    link: 'https://www.linkedin.com/in/vedmich/?lipi=urn%3Ali%3Apage%3Ad_flagship3_company%3B69Jch7qRSgGACXdoKM8F9A%3D%3D',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Denis Astahov',
    position: 'AWS Hero Solutions Architect at OpsGuru, Founder of ADV-IT',
    isKeyNoteSpeaker: true,
    videoUrl: 'https://www.youtube.com/embed/Cq9FxNwlXWk?si=i3y_BIeMuOvdhSCr',
    image: DenisPhoto,
    link: 'https://www.linkedin.com/in/denis-astahov/?lipi=urn%3Ali%3Apage%3Ad_flagship3_company%3B69Jch7qRSgGACXdoKM8F9A%3D%3D',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Nikita Fedkin',
    position: 'Amazon Web Services, Solutions Architect at AWS',
    image: NikitaPhoto,
    link: 'https://www.linkedin.com/in/nikitafed/?lipi=urn%3Ali%3Apage%3Ad_flagship3_company%3B69Jch7qRSgGACXdoKM8F9A%3D%3D',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Hovhannes Mikayelyan',
    position: 'DevOps Engineer',
    image: HovoPhoto,
    link: 'https://www.linkedin.com/in/hovmikayelyan/',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Dazik Akbarov',
    position: 'Lead Software Engineer at EPAM Systems',
    image: DazikPhoto,
    link: 'https://www.linkedin.com/in/saidazizkhon-akbarov/',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Said Akhmed Agitaev',
    position: 'Lead Software Engineers at EPAM Systems',
    image: SaidPhoto,
    link: 'https://www.linkedin.com/in/agitaev?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAACAqnnQB7kRBeddqu6YOnWsNxIsM_de8eaQ&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_people%3By7h%2B%2FDU6Q02zCnRSh%2Fj7tA%3D%3D',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Tigran Hunanyan',
    position: 'Tech. Lead - Digital Channels at Ameriabank',
    image: TigranPhoto,
    link: 'https://www.linkedin.com/in/tigran-hunanyan-42490923?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAATwmxwBIYFaSERWRbln80k9HWrg8zHa00M&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3Bb2g4aTCtQne9JPFQzoSpMA%3D%3D',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Alexey Eremin',
    position: 'Cloud Engineering Specialist at FivexL',
    image: AlexeyPhoto,
    link: 'https://www.linkedin.com/in/alexey-eremin/?lipi=urn%3Ali%3Apage%3Ad_flagship3_company%3B69Jch7qRSgGACXdoKM8F9A%3D%3D',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Petr Kalmukhyan',
    position: 'Senior DevOps at TSS Paratransit.',
    image: PetrPhoto,
    link: 'https://www.linkedin.com/in/petr-kalmukhyan/?lipi=urn%3Ali%3Apage%3Ad_flagship3_company%3B69Jch7qRSgGACXdoKM8F9A%3D%3D',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Anton Eremin',
    position: 'Cloud Engineering Specialist at FivexL',
    image: AntonPhoto,
    link: 'https://www.linkedin.com/in/anton-eremin-75aab725a/?lipi=urn%3Ali%3Apage%3Ad_flagship3_company%3B69Jch7qRSgGACXdoKM8F9A%3D%3D',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Sam Mosleh',
    position: 'Senior Software Engineer at Axcient',
    image: SamPhoto,
    link: 'https://www.linkedin.com/in/mosleh-sam?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAEOjGqcBgAemjq9DLSL4tjXtQTPO3_Xx1-E&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BMu%2BCyALbRcOd7ArVqtnNdQ%3D%3D',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Mikayel Ghazaryan',
    position: 'Lead Cloud Architect at Aconso AG',
    image: MikayelPhoto,
    link: 'https://www.linkedin.com/in/mkdotam?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAACEU0MBmC54yAROZvn2GMZsQQ4cH5LGl4c&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BBNznvB0yTqepPi4OTvvdcQ%3D%3D',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Vahan Terzibashian',
    position: 'DevOps Architect at Skyscrapers',
    image: VahanPhoto,
    link: 'https://www.linkedin.com/in/vahan-terzibashian?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAAfqhJgBFjv9A-lSEirphB_gsrfz-vF1OCs&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BmOi2MyFYRkmeHzPa7la48A%3D%3D',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Irine Kokilashvili',
    position: 'Lead System Engineer',
    image: IrinePhoto,
    link: 'https://www.linkedin.com/in/irine-kokilashvili/',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Gagik Khalafyan',
    position: 'Data Scientist at EPAM',
    image: GagikPhoto,
    link: 'https://www.linkedin.com/in/gagik-khalafyan-b033a0211?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAADWg5DMB_dbJdlQXGCxeIEk34bsqF9hjWIM&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BbLS%2FLFmiTgOkdWyRPValEA%3D%3D',
    style: {
      objectPosition: 'center 26%',
    },
  },
]

export default speakersData2024
